import { DeleteModal as SuccessModal } from '@ui'

type Props = {
  onClose?: () => void
  onSubmit?: () => void
  defaultData?: any
  isLoading?: boolean
}

const AllergyWarning = ({ onClose, onSubmit = () => {}, defaultData, isLoading }: Props) => {
  return (
    <SuccessModal
      description="This patient is allergic to this drug.  Are you sure you want to continue with this order"
      handleSubmit={() => {
        onSubmit()
        onClose && onClose()
      }}
      isLoading={isLoading}
      lBtnLabel="Cancel Order"
      onClose={onClose}
      rBtnLabel="Continue with Order"
      title="Allergy Conflict Detected"
    />
  )
}

export default AllergyWarning
